import React from 'react';
import { Box } from '@mui/material';
import { ContactForm } from './ContactForm';
import { Navbar } from './Navbar';
import bgImage from '../../assets/images/bg-app-4.jpg';

export const Contact: React.FC = () => {
  const handleContactClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box>
      <Navbar onContactClick={handleContactClick} />
      <Box sx={{ 
        minHeight: '100vh',
        width: '100%',
        py: 8,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
        <ContactForm />
      </Box>
    </Box>
  );
};
